import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpContextToken,
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { fetchAuthSession } from 'aws-amplify/auth';

const RETRY_AUTH = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private apiBaseUrl = environment.apiUrl;

  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.url.startsWith(this.apiBaseUrl)) {
      return from(fetchAuthSession()).pipe(
        switchMap((session) => {
          const accessToken = session.tokens?.accessToken?.toString();

          if (accessToken) {
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${accessToken}`,
              },
            });
          }

          return next.handle(request);
        }),
      );
    }

    return next.handle(request);
  }
}
